export enum ContactEmailType {
  REQUEST_DRAW_FROM_BUILDER = "REQUEST_DRAW_FROM_BUILDER",
  REQUEST_BUDGET_FROM_BUILDER = "REQUEST_BUDGET_FROM_BUILDER",
  REQUEST_APPROVAL_FROM_LENDER = "REQUEST_APPROVAL_FROM_LENDER",
  REQUEST_DRAW_FROM_BORROWER = "REQUEST_DRAW_FROM_BORROWER",
  ATTENTION_TO_FUNDING_TO_BORROWER = "ATTENTION_TO_FUNDING_TO_BORROWER",
  REQUEST_BUDGET_FROM_BORROWER = "REQUEST_BUDGET_FROM_BORROWER",
  REQUEST_INSPECTION_FROM_INSPECTOR = "REQUEST_INSPECTION_FROM_INSPECTOR",
  REQUEST_INSPECTION_FROM_APPRAISER = "REQUEST_INSPECTION_FROM_APPRAISER",
  REQUEST_SURVEY_FROM_SURVEYOR = "REQUEST_SURVEY_FROM_SURVEYOR",
  REQUEST_INFO_FROM_TITLE_COMPANY = "REQUEST_INFO_FROM_TITLE_COMPANY",
  REQUEST_INFO_FROM_ARCHITECT = "REQUEST_INFO_FROM_ARCHITECT",
  ATTENTION_TO_FUNDING = "ATTENTION_TO_FUNDING",
  NEW_DRAW_NOTIFICATION = "NEW_DRAW_NOTIFICATION",
}
